export default __webpack_public_path__ + "static/media/ic_back.3c3686b7.svg";